/**
 * Normalizes balance values from API/socket for storage and display.
 * Fixes scientific notation and negligible amounts (e.g. 5.115907697472721E-12 → 0).
 *
 * @param {number|string} raw - Balance from bet_ack, get_user_balance, etc.
 * @param {number} [decimals=2] - Currency decimal places; used to decide "negligible" threshold.
 * @returns {number} Normalized balance (negligible values become 0).
 */
export function normalizeBalance(raw, decimals = 2) {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 0;
  const threshold = 0.5 / Math.pow(10, decimals);
  if (Math.abs(n) < threshold) return 0;
  return n;
}
